import type { OverlayOptions } from '../../plugin';

export interface PanelOverlayOptions extends OverlayOptions {
    panelOptions: PanelOptions
}

export interface PanelOptions {
    position: PanelPosition
}

export enum PanelPosition {
    LEFT = 'LEFT',
    RIGHT ='RIGHT',
    TOP = 'TOP',
    BOTTOM ='BOTTOM'
}

export interface PopupOverlayOptions extends OverlayOptions {
    tooltipOptions: PopupOptions
}

export interface PopupPlacementOption {
    side: PopupSide[]|string
    position: PopupPosition[]|string
}

export interface PopupPlacement {
    side: PopupSide[]
    position: PopupPosition[]
}

export interface ResolvedPopupPlacement {
    side: PopupSide
    position: PopupPosition
}

export interface PopupOptions {
    anchor: Element|Partial<DOMRect>
    placement?: PopupPlacementOption|string|PopupSide[]
    container?: Element
    pointerEvents?: boolean
    margin?: number
    distance?: number
}

export interface PopupDisplay {
    placement: ResolvedPopupPlacement
    position: {
        x: number
        y: number
    }
}

export enum PopupSide {
    LEFT = 'left',
    RIGHT = 'right',
    BOTTOM = 'bottom',
    TOP = 'top'
}

export enum PopupPosition {
    START = 'start',
    CENTER = 'center',
    END = 'end'
}